export default __webpack_public_path__ + "static/media/786.683d33e6.png";